import React from 'react';
import BaseSkeleton from './BaseSkeleton';

const FormDataViewSkeleton = () => {
  return (
    <div className="p-4">
      <div className="space-y-5">
        <div className="space-y-2">
          <BaseSkeleton className="h-6 w-3/4" rounded="rounded-md" />
          <BaseSkeleton className="h-4 w-full" rounded="rounded-md" />
          <BaseSkeleton className="h-4 w-2/3" rounded="rounded-md" />
        </div>
        
        <div className="grid grid-cols-2 gap-3">
          <div className="bg-white border border-gray-200 rounded-lg p-5">
            <BaseSkeleton className="h-3 w-16 mb-2" rounded="rounded-sm" />
            <BaseSkeleton className="h-4 w-full" rounded="rounded-md" />
          </div>
          <div className="bg-white border border-gray-200 rounded-lg p-5">
            <BaseSkeleton className="h-3 w-20 mb-2" rounded="rounded-sm" />
            <BaseSkeleton className="h-4 w-full" rounded="rounded-md" />
            <BaseSkeleton className="h-3 w-16 mt-1" rounded="rounded-sm" />
          </div>
        </div>
        
        <div className="space-y-6">
          {[...Array(6)].map((_, index) => (
            <div key={index} className="space-y-3">
              <div className="flex items-start gap-2">
                <BaseSkeleton className="h-4 w-4" rounded="rounded-sm" />
                <BaseSkeleton className="h-4 w-3/4" rounded="rounded-md" />
              </div>
              <div className="ml-6">
                <BaseSkeleton className="h-10 w-full" rounded="rounded-md" />
                {index % 3 === 0 && (
                  <BaseSkeleton className="h-10 w-2/3 mt-2" rounded="rounded-md" />
                )}
              </div>
            </div>
          ))}
        </div>
        
        <div className="pt-6">
          <BaseSkeleton className="w-full h-14" rounded="rounded-xl" />
        </div>
      </div>
    </div>
  );
};

export default FormDataViewSkeleton;